var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",class:_vm.good.id===_vm.indexId?'btn-act':'',on:{"click":_vm.onClick}},[_c('div',[_vm._v(_vm._s(_vm.good.gcName))])])}
var staticRenderFns = []

export { render, staticRenderFns }